window.dataLayer = window.dataLayer || [];

/* =========================
   FIRST PARTY ID (FPID)
========================= */
function getOrCreateFPID() {
  var name = '_osh_fpid';
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];

  var id = 'fpid_' + Math.random().toString(36).substr(2, 12) + Date.now();
  document.cookie = name + '=' + id + '; path=/; max-age=' + (60 * 60 * 24 * 365 * 2);
  return id;
}

var FPID = getOrCreateFPID();
var OSH_ABANDONMENT_ENDPOINT = 'https://emails.orthoticshop.com/abandonment-event.php';

/* =========================
   EMAILBRO ABANDONMENT EVENTS
========================= */
function getCookieValue(name) {
  var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : '';
}

function cleanAbandonmentValue(value, maxLen) {
  value = value == null ? '' : String(value).trim();
  if (!value) return '';
  return value.length > maxLen ? value.substring(0, maxLen) : value;
}

function getEmailBroAttribution() {
  return {
    eb_source: cleanAbandonmentValue(getCookieValue('osh_eb_source'), 64),
    eb_campaign_id: cleanAbandonmentValue(getCookieValue('osh_eb_campaign_id'), 20),
    eb_send_id: cleanAbandonmentValue(getCookieValue('osh_eb_send_id'), 20),
    eb_automation_send_id: cleanAbandonmentValue(getCookieValue('osh_eb_automation_send_id'), 20),
    eb_automation: cleanAbandonmentValue(getCookieValue('osh_eb_automation'), 64),
    eb_step: cleanAbandonmentValue(getCookieValue('osh_eb_step'), 64)
  };
}

function getSocialBroAssist() {
  var raw = '';
  try {
    raw = window.sessionStorage ? (sessionStorage.getItem('osh_socialbro_assist') || '') : '';
  } catch (e) {
    raw = '';
  }
  if (!raw) raw = getCookieValue('osh_socialbro_assist');
  if (!raw) return {};

  try {
    var assist = JSON.parse(raw);
    var ts = Number(assist.ts || 0);
    if (ts && Date.now() - ts > 14 * 24 * 60 * 60 * 1000) return {};
    return {
      socialbro_assist_source: cleanAbandonmentValue(assist.source, 64),
      socialbro_assist_event: cleanAbandonmentValue(assist.event, 96),
      socialbro_assist_product_id: cleanAbandonmentValue(assist.product_id, 64),
      socialbro_assist_asset_id: cleanAbandonmentValue(assist.asset_id, 500),
      socialbro_assist_placement: cleanAbandonmentValue(assist.placement, 128),
      socialbro_assist_title: cleanAbandonmentValue(assist.title, 255),
      socialbro_assist_ts: cleanAbandonmentValue(assist.ts, 32)
    };
  } catch (e) {
    return {};
  }
}

function hasSocialBroAssist(assist) {
  assist = assist || {};
  return !!(assist.socialbro_assist_source || assist.socialbro_assist_event || assist.socialbro_assist_product_id || assist.socialbro_assist_asset_id);
}

function hasEmailBroAttribution(attrs) {
  attrs = attrs || {};
  return !!(attrs.eb_send_id || attrs.eb_campaign_id || attrs.eb_automation_send_id || attrs.eb_automation);
}

function isTrackableCartItem(item) {
  item = item || {};
  var sku = String(item.sku || item.variant_sku || item.id || '').trim().toLowerCase();
  var title = String(item.product_title || item.title || item.name || '').trim().toLowerCase();

  if (sku.indexOf('x-redo') === 0) return false;
  if (sku.indexOf('redo') === 0) return false;
  if (title.indexOf('redo') !== -1 && title.indexOf('return') !== -1) return false;

  return true;
}

function cartItemToAbandonmentItem(item) {
  item = item || {};
  var price = Number(item.final_price || item.price || 0) / 100;
  return {
    item_id: String(item.sku || item.variant_id || item.id || ''),
    variant_id: String(item.variant_id || ''),
    product_id: String(item.product_id || ''),
    item_name: item.product_title || item.title || '',
    item_variant: item.variant_title || '',
    item_brand: item.vendor || '',
    price: isNaN(price) ? 0 : price,
    quantity: Number(item.quantity || 1),
    url: item.url || '',
    image: item.image || ''
  };
}

function postAbandonmentEvent(payload) {
  payload = payload || {};
  payload.fpid = FPID;
  payload.current_url = window.location.href;
  payload.landing_url = getCookieValue('osh_landing_url') || window.location.href;
  payload.referrer = document.referrer || '';
  payload.attribution = payload.attribution || getEmailBroAttribution();

  if (!payload.email && window.oshCustomer && window.oshCustomer.email) {
    payload.email = window.oshCustomer.email;
  }

  try {
    fetch(OSH_ABANDONMENT_ENDPOINT, {
      method: 'POST',
      mode: 'cors',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).catch(function() {});
  } catch (e) {}
}

function postCartAbandonmentSnapshot(reason, email) {
  var attrs = getEmailBroAttribution();
  email = cleanAbandonmentValue(email, 255);
  if (!hasEmailBroAttribution(attrs) && !(window.oshCustomer && window.oshCustomer.email) && !email) {
    return;
  }

  fetch('/cart.js', {
    method: 'GET',
    headers: { 'Accept': 'application/json' }
  }).then(function(response) {
    return response.json();
  }).then(function(cart) {
    if (!cart) return;
    var cartItems = cart.items || [];
    var trackableItems = cartItems.filter(isTrackableCartItem);
    if (!trackableItems.length && !email) return;
    var subtotal = Number(cart.total_price || cart.items_subtotal_price || 0) / 100;
    postAbandonmentEvent({
      event_type: 'cart_activity',
      source_event: reason || 'cart_activity',
      session_key: FPID,
      cart_token: cart.token || '',
      email: email,
      currency: cart.currency || 'USD',
      subtotal: isNaN(subtotal) ? 0 : subtotal,
      items: trackableItems.map(cartItemToAbandonmentItem),
      attribution: attrs
    });
  }).catch(function() {});
}

/* =========================
   HASHING (SHA-256)
========================= */
async function sha256(str) {
  if (!str || !window.crypto || !crypto.subtle) return null;

  var buf = new TextEncoder().encode(String(str).trim().toLowerCase());
  var hash = await crypto.subtle.digest('SHA-256', buf);

  return Array.from(new Uint8Array(hash))
    .map(function(b) { return b.toString(16).padStart(2, '0'); })
    .join('');
}

/* =========================
   USER DATA
========================= */
async function buildUserData() {
  var email = window.oshCustomer && window.oshCustomer.email ? window.oshCustomer.email : null;
  var phone = window.oshCustomer && window.oshCustomer.phone ? window.oshCustomer.phone : null;

  return {
    em: await sha256(email),
    ph: await sha256(phone),
    external_id: FPID
  };
}

/* =========================
   PAGE TYPE
========================= */
function getPageType(eventName) {
  var path = window.location.pathname || '';

  if (eventName === 'purchase') return 'purchase';
  if (eventName === 'begin_checkout') return 'cart';
  if (eventName === 'add_to_cart') return 'cart';
  if (eventName === 'view_item') return 'product';

  if (path === '/' || path === '') return 'home';
  if (path.indexOf('/products/') > -1) return 'product';
  if (path.indexOf('/collections/') > -1) return 'category';
  if (path.indexOf('/cart') > -1) return 'cart';

  return 'other';
}

/* =========================
   OSH TRACK HELPER
   Used by GTM Meta/TikTok/Criteo/Google tags
========================= */
window.oshTrackHelper = window.oshTrackHelper || {
  getEcommerce: function(eventName) {
    var dl = window.dataLayer || [];

    for (var i = dl.length - 1; i >= 0; i--) {
      if (dl[i] && dl[i].event === eventName && dl[i].ecommerce) {
        return dl[i].ecommerce;
      }
    }

    return {};
  },

  itemsFrom: function(e) {
    return e && e.items ? e.items : [];
  },

  ids: function(items) {
    var out = [];

    for (var i = 0; i < (items || []).length; i++) {
      var id = items[i].item_id || items[i].id || items[i].sku || '';
      if (id) out.push(String(id));
    }

    return out;
  },

  contents: function(items) {
    var out = [];

    for (var i = 0; i < (items || []).length; i++) {
      var productId = String(
        items[i].item_id ||
        items[i].id ||
        items[i].sku ||
        ''
      );

      var price = Number(items[i].price || items[i].item_price || 0);
      var quantity = Number(items[i].quantity || 1);

      out.push({
        id: productId,              // Meta/Criteo-style
        content_id: productId,      // TikTok-style
        content_type: 'product',
        content_name: items[i].item_name || '',
        quantity: quantity,
        price: price,
        item_price: price
      });
    }

    return out;
  },

  pageType: function(eventName) {
    return getPageType(eventName);
  }
};

/* =========================
   EVENT PUSH
========================= */
async function pushEvent(eventName, ecommerceData) {
  ecommerceData = ecommerceData || {};
  ecommerceData.page_type = ecommerceData.page_type || getPageType(eventName);

  var userData = await buildUserData();
  var socialBroAssist = getSocialBroAssist();
  if (hasSocialBroAssist(socialBroAssist)) {
    Object.keys(socialBroAssist).forEach(function(key) {
      ecommerceData[key] = socialBroAssist[key];
    });
  }

  window.dataLayer.push({ ecommerce: null });

  var payload = {
    event: eventName,
    ecommerce: ecommerceData,
    user_data: userData,
    user_id: FPID,
    event_id: eventName + '_' + Date.now()
  };
  if (hasSocialBroAssist(socialBroAssist)) {
    Object.keys(socialBroAssist).forEach(function(key) {
      payload[key] = socialBroAssist[key];
    });
  }

  window.dataLayer.push(payload);
}

/* =========================
   GET SELECTED VARIANT
========================= */
function getSelectedVariant() {
  // 1. form selection
  var formId = document.querySelector('[name="id"]');
  if (formId && window.productData && window.productData.variants) {
    var v = window.productData.variants.find(function(variant) {
      return String(variant.id) === String(formId.value);
    });

    if (v) return v;
  }

  // 2. URL ?variant=
  var params = new URLSearchParams(window.location.search);
  var variantId = params.get('variant');

  if (variantId && window.productData && window.productData.variants) {
    var v2 = window.productData.variants.find(function(variant) {
      return String(variant.id) === String(variantId);
    });

    if (v2) return v2;
  }

  // 3. theme-selected variant
  if (window.selectedVariant) return window.selectedVariant;

  // 4. fallback
  return window.productData && window.productData.variants
    ? window.productData.variants[0]
    : null;
}

/* =========================
   VIEW ITEM
========================= */
(async function() {
  if (!window.productData) return;

  var variant = getSelectedVariant();
  if (!variant) return;

  var price = parseFloat(variant.price) / 100;

  await pushEvent('view_item', {
    currency: 'USD',
    value: price,
    page_type: 'product',
    items: [{
      item_id: variant.sku || variant.id,
      item_name: window.productData.title,
      item_brand: window.productData.vendor,
      item_category: (window.oshProductMeta && window.oshProductMeta.product_type)
        ? window.oshProductMeta.product_type
        : (window.productData.type || ''),
      item_variant: variant.title,
      price: price,
      quantity: 1,
      item_group_id: window.productData.id
    }]
  });
})();

/* =========================
   ADD TO CART
========================= */
document.addEventListener('submit', function(e) {
  var form = e.target;
  if (!form.matches('form[action*="/cart/add"]')) return;

  setTimeout(async function() {
    try {
      var variant = getSelectedVariant();
      if (!variant || !window.productData) return;

      var qtyInput = form.querySelector('[name="quantity"]');
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (!quantity || quantity < 1) quantity = 1;

      var price = parseFloat(variant.price) / 100;

      await pushEvent('add_to_cart', {
        currency: 'USD',
        value: price * quantity,
        page_type: 'cart',
        items: [{
          item_id: variant.sku || variant.id,
          item_name: window.productData.title,
          item_brand: window.productData.vendor,
          item_category: (window.oshProductMeta && window.oshProductMeta.product_type)
            ? window.oshProductMeta.product_type
            : (window.productData.type || ''),
          item_variant: variant.title,
          price: price,
          quantity: quantity,
          item_group_id: window.productData.id
        }]
      });

      setTimeout(function() {
        postCartAbandonmentSnapshot('add_to_cart');
      }, 600);

      console.log('ATC fired', variant.sku || variant.id);

    } catch (err) {
      console.error('ATC error', err);
    }
  }, 200);
});

/* =========================
   CART PAGE SNAPSHOT
========================= */
if ((window.location.pathname || '').indexOf('/cart') === 0) {
  setTimeout(function() {
    postCartAbandonmentSnapshot('cart_page');
  }, 1000);
}

/* =========================
   SIGNUP FORM CART IDENTITY
========================= */
document.addEventListener('submit', function(e) {
  var form = e.target;
  if (!form || !form.matches || !form.matches('form')) return;

  var action = String(form.getAttribute('action') || '').toLowerCase();
  if (action.indexOf('signup-receiver.php') === -1 && action.indexOf('emails.orthoticshop.com') === -1) {
    return;
  }

  var emailInput = form.querySelector('input[type="email"], input[name="email"]');
  var email = emailInput ? String(emailInput.value || '').trim().toLowerCase() : '';
  if (!email || email.indexOf('@') === -1) return;

  postCartAbandonmentSnapshot('signup_submit', email);
});
/* Pure attribution planning only. The server MUST verify the HMAC and tenancy. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.BisRevenueCartCapture = factory();
}(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  var WINDOW = 604800;
  var competing = ['eb_source', 'eb_campaign_id', 'eb_send_id', 'eb_automation_send_id', 'eb_automation', 'eb_step'];
  function integer(value) { return Number.isSafeInteger(value) && value > 0; }
  function safeId(value) { return typeof value === 'string' && /^[A-Za-z0-9_-]{1,128}$/.test(value); }
  function decode(body) {
    var base64 = body.replace(/-/g, '+').replace(/_/g, '/');
    if (typeof atob === 'function') return atob(base64);
    return Buffer.from(base64, 'base64').toString('ascii');
  }
  function encode(raw) {
    var encoded = typeof btoa === 'function' ? btoa(raw) : Buffer.from(raw, 'ascii').toString('base64');
    return encoded.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function validate(token, now) {
    if (typeof token !== 'string' || token.length > 1024 || !Number.isSafeInteger(now)) return null;
    var match = /^([A-Za-z0-9_-]+)\.([a-f0-9]{64})$/.exec(token);
    if (!match) return null;
    try {
      var raw = decode(match[1]), p = JSON.parse(raw);
      if (!p || Array.isArray(p) || Object.keys(p).sort().join(',') !== 'c,i,m,n,q,v,x' ||
          p.v !== 1 || !integer(p.q) || typeof p.n !== 'string' || !/^[a-f0-9]{32}$/.test(p.n) ||
          !safeId(p.m) || !safeId(p.i) || !integer(p.c) || !integer(p.x) ||
          p.x !== p.c + WINDOW || p.c > now + 60 || now >= p.x) return null;
      var canonical = JSON.stringify({v:p.v,q:p.q,n:p.n,m:p.m,i:p.i,c:p.c,x:p.x});
      if (canonical !== raw || encode(raw) !== match[1]) return null;
      return p;
    } catch (_) { return null; }
  }
  // query is URLSearchParams, a query string, or a plain key/value object;
  // cookies is a plain map of already-decoded cookie values. now is Unix seconds.
  function capture(state) {
    state = state || {};
    var query = state.query || {}, cookies = state.cookies || {}, now = state.now;
    if (typeof query === 'string') query = new URLSearchParams(query);
    function get(name) { return typeof query.get === 'function' ? query.get(name) : query[name]; }
    var result = {attrs:{}, setCookies:[], clearCookies:[]};
    function clearBis() { result.attrs.eb_bis = ''; result.clearCookies.push('osh_eb_bis'); }
    // A fresh campaign/automation URL takes priority over an ambiguous BIS URL.
    // Existing campaign capture remains responsible for its own values.
    if (competing.slice(1).some(function (key) {
      var value = get(key);
      return typeof value === 'string' && value.trim() !== '';
    })) { clearBis(); return result; }
    var fresh = get('eb_bis');
    var token = fresh !== null && fresh !== undefined ? fresh : cookies.osh_eb_bis;
    if (token === undefined || token === null) return result;
    var payload = validate(token, now);
    if (!payload) { clearBis(); return result; }
    result.attrs.eb_bis = token;
    result.attrs.eb_source = 'emailbro';
    competing.forEach(function (key) {
      result.clearCookies.push('osh_' + key);
      if (key !== 'eb_source') result.attrs[key] = '';
    });
    // Re-setting uses the original signed deadline, never a sliding window.
    ['eb_bis', 'eb_source'].forEach(function (key) {
      result.setCookies.push({name:'osh_' + key, value:result.attrs[key], expires:payload.x, maxAge:Math.min(WINDOW, payload.x - now)});
    });
    return result;
  }
  return {capture:capture, validate:validate};
}));

/*gclid msclk*/
(function () {
  function getParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (e) {
      return '';
    }
  }

  function setCookie(name, value, days) {
    if (!value) return;
    document.cookie =
      name + '=' + encodeURIComponent(value) +
      '; path=/; max-age=' + (days * 24 * 60 * 60) +
      '; SameSite=Lax';
  }

  function cleanAttr(value, maxLen) {
    value = value ? String(value).trim() : '';
    if (!value) return '';
    value = value.replace(/[^A-Za-z0-9_.:-]/g, '');
    return value.length > maxLen ? value.substring(0, maxLen) : value;
  }

  function opaqueAttr(value, maxLen) {
    value = value ? String(value).trim() : '';
    return value.length > maxLen ? value.substring(0, maxLen) : value;
  }

  function metaFbcFromClick(fbclid, existingFbc) {
    fbclid = cleanAttr(fbclid, 200);
    if (!fbclid) return existingFbc || '';
    var match = /^fb\.[0-9]+\.[0-9]{13}\.(.+)$/.exec(existingFbc || '');
    if (match && match[1] === fbclid) return existingFbc;
    return 'fb.1.' + Date.now() + '.' + fbclid;
  }

  function parseGaClientId(gaCookie) {
    if (!gaCookie) return '';
    var parts = String(gaCookie).split('.');
    if (parts.length >= 4) {
      return parts[2] + '.' + parts[3];
    }
    return '';
  }

  function parseGa4SessionCookie(cookieValue) {
    var out = {
      ga_session_id: '',
      ga_session_number: ''
    };

    if (!cookieValue) return out;

    var value = String(cookieValue);
    var sidMatch = value.match(/(?:^|\$)s(\d+)/);
    var snMatch = value.match(/(?:^|\$)o(\d+)/);

    if (sidMatch && sidMatch[1]) out.ga_session_id = sidMatch[1];
    if (snMatch && snMatch[1]) out.ga_session_number = snMatch[1];

    if (!out.ga_session_id) {
      var parts = value.split('.');
      if (parts.length >= 3 && /^\d+$/.test(parts[2])) {
        out.ga_session_id = parts[2];
      }
      if (parts.length >= 4 && /^\d+$/.test(parts[3])) {
        out.ga_session_number = parts[3];
      }
    }

    return out;
  }

  function attrValueFromParamOrCookie(paramName, cookieName, maxLen) {
    return cleanAttr(getParam(paramName), maxLen) || cleanAttr(getCookieValue(cookieName), maxLen);
  }

  function captureEmailBroParam(paramName, maxLen) {
    var value = attrValueFromParamOrCookie(paramName, 'osh_' + paramName, maxLen);
    if (!value) return;
    setCookie('osh_' + paramName, value, 14);
    attrs[paramName] = value;
  }

  function updateCartAttrs(attrs) {
    if (!attrs || !Object.keys(attrs).length) return;
    try {
      var cacheKey = 'osh_last_cart_attrs';
      var encoded = JSON.stringify(attrs);
      if (window.sessionStorage && sessionStorage.getItem(cacheKey) === encoded) {
        return;
      }
    } catch (e) {}

    fetch('/cart/update.js', {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function(response) {
      if (!response.ok) throw new Error('Cart attributes not saved');
      // Cache only a successful write; a network failure must remain retryable.
      try { sessionStorage.setItem(cacheKey, encoded); } catch (e) {}
    }).catch(function () {});
  }

  var attrs = {};

  var gclid = attrValueFromParamOrCookie('gclid', 'osh_gclid', 255);
  if (gclid) {
    setCookie('osh_gclid', gclid, 90);
    attrs.gclid = gclid;
  }

  var gbraid = attrValueFromParamOrCookie('gbraid', 'osh_gbraid', 255);
  if (gbraid) {
    setCookie('osh_gbraid', gbraid, 90);
    attrs.gbraid = gbraid;
  }

  var wbraid = attrValueFromParamOrCookie('wbraid', 'osh_wbraid', 255);
  if (wbraid) {
    setCookie('osh_wbraid', wbraid, 90);
    attrs.wbraid = wbraid;
  }

  // OpenAI Ads identifiers are opaque and must be preserved unchanged.
  var oppref = opaqueAttr(getParam('oppref'), 512) || opaqueAttr(getCookieValue('osh_oppref'), 512) || opaqueAttr(getCookieValue('__oppref'), 512);
  if (oppref) {
    setCookie('osh_oppref', oppref, 90);
    attrs.oppref = oppref;
  }

  var openaiObref = opaqueAttr(getCookieValue('__obref'), 255) || opaqueAttr(getCookieValue('osh_openai_obref'), 255);
  if (openaiObref) {
    setCookie('osh_openai_obref', openaiObref, 90);
    attrs.openai_obref = openaiObref;
  }

  // Our reporting IDs are separate from OpenAI's opaque, provider-issued oppref.
  ['openai_campaign_id', 'openai_ad_group_id', 'openai_ad_id', 'openai_ad_account_id'].forEach(function(name) {
    var value = attrValueFromParamOrCookie(name, 'osh_' + name, 128);
    if (value && value.indexOf('{') === -1) {
      setCookie('osh_' + name, value, 90);
      attrs[name] = value;
    }
  });

  var msclkid = attrValueFromParamOrCookie('msclkid', 'osh_msclkid', 255) || cleanAttr(getCookieValue('_uetmsclkid'), 255);
  if (msclkid) {
    setCookie('osh_msclkid', msclkid, 90);
    attrs.msclkid = msclkid;
  }

  var uetvid = cleanAttr(getCookieValue('_uetvid'), 255);
  if (uetvid) attrs.uetvid = uetvid;

  var uetsid = cleanAttr(getCookieValue('_uetsid'), 255);
  if (uetsid) attrs.uetsid = uetsid;

  var fbclid = getParam('fbclid');
  var fbc = cleanAttr(getCookieValue('_fbc'), 255) || cleanAttr(getCookieValue('osh_fbc'), 255);
  if (fbclid) {
    fbc = metaFbcFromClick(fbclid, fbc);
    setCookie('_fbc', fbc, 90);
    setCookie('osh_fbc', fbc, 90);
  }
  if (fbc) {
    attrs.fbc = fbc;
  }

  var fbp = cleanAttr(getCookieValue('_fbp'), 255) || cleanAttr(getCookieValue('osh_fbp'), 255);
  if (fbp) {
    setCookie('osh_fbp', fbp, 90);
    attrs.fbp = fbp;
  }

  var ttclid = attrValueFromParamOrCookie('ttclid', 'osh_ttclid', 255);
  if (ttclid) {
    setCookie('osh_ttclid', ttclid, 90);
    attrs.ttclid = ttclid;
  }

  var rdtCid = attrValueFromParamOrCookie('rdt_cid', 'osh_rdt_cid', 255);
  if (rdtCid) {
    setCookie('osh_rdt_cid', rdtCid, 90);
    attrs.rdt_cid = rdtCid;
  }

  var rdtUuid = cleanAttr(getCookieValue('_rdt_uuid'), 255) || cleanAttr(getCookieValue('osh_rdt_uuid'), 255);
  if (rdtUuid) {
    setCookie('osh_rdt_uuid', rdtUuid, 90);
    attrs.rdt_uuid = rdtUuid;
  }

  var ttp = cleanAttr(getCookieValue('_ttp'), 255) || cleanAttr(getCookieValue('osh_ttp'), 255);
  if (ttp) {
    setCookie('osh_ttp', ttp, 90);
    attrs.ttp = ttp;
  }

  var gaClientId = cleanAttr(parseGaClientId(getCookieValue('_ga')), 128);
  if (gaClientId) attrs.ga_client_id = gaClientId;

  var ga4SessionData = parseGa4SessionCookie(getCookieValue('_ga_XSWEW8V12F'));
  if (!ga4SessionData.ga_session_id) {
    ga4SessionData = parseGa4SessionCookie(getCookieValue('_ga_HR9MP6ENEP'));
  }
  if (ga4SessionData.ga_session_id) attrs.ga_session_id = cleanAttr(ga4SessionData.ga_session_id, 64);
  if (ga4SessionData.ga_session_number) attrs.ga_session_number = cleanAttr(ga4SessionData.ga_session_number, 32);

  captureEmailBroParam('eb_source', 64);
  captureEmailBroParam('eb_campaign_id', 20);
  captureEmailBroParam('eb_send_id', 20);
  captureEmailBroParam('eb_automation_send_id', 20);
  captureEmailBroParam('eb_automation', 64);
  captureEmailBroParam('eb_step', 64);
  // Dedicated BIS last-touch tuple. Signature/accepted receipt verified server-side.
  var bisCookieNames = ['eb_bis','eb_source','eb_campaign_id','eb_send_id','eb_automation_send_id','eb_automation','eb_step'];
  var bisCookies = {};
  bisCookieNames.forEach(function(k) { bisCookies['osh_' + k] = getCookieValue('osh_' + k); });
  var bisPlan = window.BisRevenueCartCapture.capture({query:window.location.search,cookies:bisCookies,now:Math.floor(Date.now()/1000)});
  bisPlan.clearCookies.forEach(function(k) { document.cookie = k + '=; path=/; max-age=0; SameSite=Lax'; });
  bisPlan.setCookies.forEach(function(c) { document.cookie = c.name + '=' + encodeURIComponent(c.value) + '; path=/; max-age=' + c.maxAge + '; SameSite=Lax'; });
  Object.keys(bisPlan.attrs).forEach(function(k) { attrs[k] = bisPlan.attrs[k]; });


  var socialBroAssist = getSocialBroAssist();
  if (hasSocialBroAssist(socialBroAssist)) {
    Object.keys(socialBroAssist).forEach(function(key) {
      attrs[key] = socialBroAssist[key];
    });
  }

  if (Object.keys(attrs).length) {
    updateCartAttrs(attrs);
  }
  // The async OpenAI SDK can set __obref after this script initially executes.
  [1500, 5000].forEach(function(delay) {
    setTimeout(function() {
      var lateObref = opaqueAttr(getCookieValue('__obref'), 255);
      if (lateObref) {
        setCookie('osh_openai_obref', lateObref, 90);
        attrs.openai_obref = lateObref;
      }
      updateCartAttrs(attrs);
    }, delay);
  });
})();
